import 'react';
import { jsx } from '@emotion/core';
import { Container } from '@appfolio/react-gears';

function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var _ref2 = process.env.NODE_ENV === "production" ? {
  name: "m8ligf",
  styles: "width:100%;max-width:1140px;"
} : {
  name: "m8ligf",
  styles: "width:100%;max-width:1140px;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIk1haW5Db250YWluZXIudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQU1JIiwiZmlsZSI6Ik1haW5Db250YWluZXIudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0LCB7IEZDIH0gZnJvbSAncmVhY3QnO1xuaW1wb3J0IHsgQ29udGFpbmVyIH0gZnJvbSAnQGFwcGZvbGlvL3JlYWN0LWdlYXJzJztcblxuY29uc3QgTWFpbkNvbnRhaW5lcjogRkMgPSAoeyBjaGlsZHJlbiB9KSA9PiAoXG4gIDxDb250YWluZXJcbiAgICBjbGFzc05hbWU9XCJkLWZsZXggZmxleC1ncm93LTEgZmxleC1jb2x1bW4gb3ZlcmZsb3ctaGlkZGVuXCJcbiAgICBjc3M9e3tcbiAgICAgIHdpZHRoOiAnMTAwJScsXG4gICAgICBtYXhXaWR0aDogJzExNDBweCcsXG4gICAgfX1cbiAgICBzdHlsZT17eyBmbGV4OiAxIH19XG4gID5cbiAgICB7Y2hpbGRyZW59XG4gIDwvQ29udGFpbmVyPlxuKTtcblxuZXhwb3J0IGRlZmF1bHQgTWFpbkNvbnRhaW5lcjtcbiJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

var MainContainer = function MainContainer(_ref) {
  var children = _ref.children;
  return jsx(Container, {
    className: "d-flex flex-grow-1 flex-column overflow-hidden",
    css: _ref2,
    style: {
      flex: 1
    }
  }, children);
};

MainContainer.displayName = "MainContainer";
export default MainContainer;